<template>
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <card-record title="Transacción" resource="transacciones" primaryKey="idtransaccion" :record="record" :columns="columns"
        @saveChanges="handleSave" :service="service" />
    </div>
  </div>
</template>
<script>
import CardRecord from "@/components/Cards/CardRecord.vue";
import TransaccionService from "@/services/transaccion.service";
import { transaccion } from "@/models/transaccion";

export default {
  components: {
    CardRecord,
  },

  data() {
    return {
      record: {},
      columns: transaccion,
      service: TransaccionService
    }
  },

  watch: {
    $route: {
      immediate: true,
      handler(/*to, from*/) {
        TransaccionService.get(this.$route.params.id).then((data) => {
          this.record = data.record;
        }).catch((response) => {
          console.log(response);
        });
      },
    },
  },

  methods: {
    handleSave(record) {
      this.record = record;
    }
  }
};
</script>
